export default {
  headline: 'Subskrypcje użytkowników',
  subheadline: 'Konfiguracja usług powiadomień użytkownika',
  noUserSelected: 'Proszę wybrać użytkownika',
};
